export const APPRAISAL_TYPES_PATHS = Object.freeze({
  list: "appraisals/appraisal-types",
  options: "appraisals/appraisal-types/options",
  byId: (id) => `appraisals/appraisal-types/${id}`,
});

/**
 * System appraisal type names (code is assigned by backend).
 */
export const APPRAISAL_TYPE_NAME_OPTIONS = [
  { value: "Agent (Rank & File)", label: "Agent (Rank & File)" },
  { value: "Supervisor", label: "Supervisor" },
  { value: "Manager", label: "Manager" },
  { value: "HR", label: "HR" },
  { value: "Senior Manager", label: "Senior Manager" },
];

/**
 * Hardcoded appraisal type name → design code (mirrors backend).
 */
export const APPRAISAL_TYPE_NAME_TO_CODE = Object.freeze({
  "Agent (Rank & File)": "agent",
  Supervisor: "manager",
  Manager: "manager",
  HR: "manager",
  "Senior Manager": "senior_manager",
});

/** Unique design-code options for the read-only Design Code dropdown. */
export const DESIGN_CODE_OPTIONS = [
  { value: "agent", label: "agent" },
  { value: "manager", label: "manager" },
  { value: "senior_manager", label: "senior_manager" },
];

export const designCodeOptionForName = (name) => {
  const code = APPRAISAL_TYPE_NAME_TO_CODE[name];
  if (!code) return null;
  return DESIGN_CODE_OPTIONS.find((o) => o.value === code) || { value: code, label: code };
};

/**
 * Normalize list payloads from Laravel API Resources or bare arrays.
 */
export const normalizeList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
};

export const mapApiAppraisalType = (row) => ({
  id: row.id,
  name: row.name || "",
  code: row.code || "",
  description: row.description || "",
  sort_order: row.sort_order ?? 0,
  is_active: row.is_active || "y",
  designations: Array.isArray(row.designations) ? row.designations : [],
  designation_ids: Array.isArray(row.designation_ids)
    ? row.designation_ids
    : (Array.isArray(row.designations) ? row.designations.map((d) => d.id) : []),
  date_created: row.date_created,
  date_last_modified: row.date_last_modified,
});

/** Fallback options when options API is unavailable (legacy + new codes). */
export const FALLBACK_APPRAISAL_TYPE_OPTIONS = [
  { value: "agent", label: "Agent (Rank & File)", code: "agent", name: "Agent (Rank & File)" },
  { value: "supervisor", label: "Supervisor", code: "supervisor", name: "Supervisor" },
  { value: "manager", label: "Manager", code: "manager", name: "Manager" },
  { value: "hr", label: "HR", code: "hr", name: "HR" },
  { value: "senior_manager", label: "Senior Manager", code: "senior_manager", name: "Senior Manager" },
];
